import { H1 } from '@atoms/Typographies';
import { useOpenRequestList } from '@hooks/Services';
import {
    CsvDownloadOpenError
} from '@organisms/GenesisEs/Csv';
import { OpenForm } from '@organisms/GenesisEs/Forms';
import { OpenFormType } from '@organisms/GenesisEs/Forms/OpenFormType';
import { Container } from '@organisms/GenesisEs/Layouts';
import { OpenTableList } from '@organisms/GenesisEs/List';
import Head from '@organisms/Heads/Head';
import { Storage } from '@states/Storage';
import CommonTemplate from '@templates/Common';
import { useState } from 'react';
import styled from 'styled-components';

const List = () => {
    const [searchParams, setSearchParams] = useState<OpenFormType>(Storage.get(Storage.keys.GENESISES_OPENLIST));
    const openRequestList = useOpenRequestList.useAllListData(searchParams);
    const SubmitHandler = (data: OpenFormType) => {
        setSearchParams(data);
    };
    return (
        <CommonTemplate>
            <Head title="再点申込結果一覧" />

            <ListWithStyled>
                <HeadingWithStyled className="mb-4">
                    <H1>再点申込結果一覧</H1>
                </HeadingWithStyled>
                <Container title='Search' children={<OpenForm submitHandler={SubmitHandler} />} />
                <Container title='Result' children={<OpenTableList listData={openRequestList}/>} headerButton={
                    <ButtonGroupWithStyled>
                        {/* <CsvDownloadOpenApply listData={openRequestList} /> */}
                        {/* <CsvDownloadOpenComplete listData={openRequestList} /> */}
                        <CsvDownloadOpenError listData={openRequestList} />
                    </ButtonGroupWithStyled>
                } />
            </ListWithStyled>

        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`
const ButtonGroupWithStyled = styled.div`
    & > div {
        display: inline-block;
        margin-left: 4px;
        & .btn-sm {
            font-size: 12px;
        }
    }
`
const ListWithStyled = styled.div`
`

export default List;